import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { KpiMetric } from '@tradecafe/types/core'
import { DeepReadonly } from '@tradecafe/types/utils'
import { environment } from 'src/environments/environment'

const { apiUrl } = environment

@Injectable({ providedIn: 'root' })
export class KpiMetricsApiService {
  private http = inject(HttpClient)


  getKpiMetrics(query: DeepReadonly<Partial<KpiMetric>>): Promise<KpiMetric[]> {
    return this.http
      .post<{ data: KpiMetric[] }>(`${apiUrl}/carrier/kpi-metrics/query`, query)
      .toPromise()
      .then((data: any) => data)
      .catch(error => {
        throw error
      })
  }
}
